import React from 'react';
import 'twin.macro';
import Select from 'components/Form/Select2';
import { useTranslation } from 'react-i18next';

interface Props {
  onChange: (v: string) => void;
  value?: string;
  extraLarge?: boolean;
  large?: boolean;
}

const states = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
};

export function StateSelector(props: Props) {
  const { onChange, value } = props;
  const { t } = useTranslation(['zone']);
  return (
    <Select<string>
      portal
      options={Object.entries(states).map(([k, v]) => ({
        value: k,
        label: v,
      }))}
      data-testid="state-button-selector"
      value={value}
      tw="bg-white"
      large={props.large}
      extralarge={props.extraLarge}
      label={t('zone:state')}
      onChange={onChange}
    />
  );
}
